import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FETCH_PRODUCTS_REQUEST, FETCH_PRODUCTS_SUCCESS, FETCH_PRODUCTS_FAILURE } from 'actionTypes';
import createReducer from './createReducer';
var initialState = {};
var products = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, FETCH_PRODUCTS_REQUEST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, action.payload), {}, {
    isFetching: true,
    isLoaded: false,
    isRequestFailed: false
  })));
}), _defineProperty(_createReducer, FETCH_PRODUCTS_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, action.payload), {}, {
    entities: action.payload.entities,
    isFetching: false,
    isLoaded: true,
    isRequestFailed: false
  })));
}), _defineProperty(_createReducer, FETCH_PRODUCTS_FAILURE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.url, _objectSpread(_objectSpread({}, action.payload), {}, {
    isFetching: false,
    isLoaded: false,
    isRequestFailed: true
  })));
}), _createReducer));
export default products;